import React, { useEffect, useMemo, useState } from "react";

export default function AdsCarousel({
  images = [],
  intervalMs = 5000,
  linkTel = "tel:+33630789320",
  altBase = "Alexis Thery - SAFTI",
  lcp = true, // si true => 1ère image prioritaire
}) {
  const safeImages = useMemo(() => images.filter(Boolean), [images]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (safeImages.length <= 1) return;
    const t = setInterval(
      () => setIdx((p) => (p + 1) % safeImages.length),
      intervalMs,
    );
    return () => clearInterval(t);
  }, [safeImages.length, intervalMs]);

  if (safeImages.length === 0) return null;

  const current = safeImages[idx];

  // LCP optimisation: seule la toute première image doit être "eager + high"
  const isFirst = idx === 0;

  return (
    <a
      href={linkTel}
      aria-label="Appeler Alexis Thery - SAFTI"
      className="adsCarousel"
    >
      <img
        src={current}
        alt={`${altBase} (${idx + 1}/${safeImages.length})`}
        draggable="false"
        loading={lcp && isFirst ? "eager" : "lazy"}
        fetchPriority={lcp && isFirst ? "high" : "auto"}
      />
    </a>
  );
}
